import type { WeaponDefinition, WeaponContext, WeaponResult } from './types';
import { Projectile } from '../entities/projectile';
import { WA_PHYSICS } from '../core/constants';

export const WeaponDynamite: WeaponDefinition = {
  id: 'dynamite',
  name: 'Dynamite',
  icon: 'dynamite.png',
  category: 'thrown',
  maxAmmo: -1,
  maxUsesPerTurn: 1,
  powerCharging: false,
  timerAdjustable: false,
  showAimGuide: false,
  allowRetreat: true,

  fire(ctx: WeaponContext): WeaponResult {
    const { worm } = ctx;

    const dropX = worm.position.x + (worm.facing === 'right' ? 15 : -15);
    const dropY = worm.position.y + worm.getBounds().height - 5;

    const dynamite = new Projectile({
      x: dropX,
      y: dropY,
      vx: worm.velocity.x * 0.5,
      vy: Math.max(worm.velocity.y, 0),
      type: 'dynamite',
      timer: WA_PHYSICS.DYNAMITE.FUSE_TIME,
      bounceH: 0,
      bounceV: 0,
      windAffected: false,
      explosionRadius: WA_PHYSICS.DYNAMITE.EXPLOSION_RADIUS,
      maxDamage: WA_PHYSICS.DYNAMITE.MAX_DAMAGE,
      ownerId: worm.id,
    });

    return {
      success: true,
      entities: [dynamite],
    };
  },
};
